import { render, staticRenderFns } from "./TimeDelayType.vue?vue&type=template&id=80e7b7d6&"
import script from "./TimeDelayType.vue?vue&type=script&lang=js&"
export * from "./TimeDelayType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80e7b7d6')) {
      api.createRecord('80e7b7d6', component.options)
    } else {
      api.reload('80e7b7d6', component.options)
    }
    module.hot.accept("./TimeDelayType.vue?vue&type=template&id=80e7b7d6&", function () {
      api.rerender('80e7b7d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/components/TimeDelayType.vue"
export default component.exports